import { ReactElement, useState, useEffect } from "react"
import {
  gql,
  graphQueryBang,
  myAppletsNormalizedAppletFields,
} from "shared/lib/graphql"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import { Applet } from "types"

interface Props {
  applet: Applet
}

const AppletRecommendations = ({ applet }: Props): ReactElement => {
  if (applet?.status !== "enabled_for_user") return null

  const [recommendedApplets, setRecommendedApplets] = useState([])

  useEffect(() => {
    const isDesktop = window.matchMedia?.(`(min-width: 850px)`)?.matches
    AppletRecommendations.fetchRecommendedApplets(applet.services, isDesktop)
      .then((data: any) => {
        setRecommendedApplets(data.recommended_applets_for_channels)
      })
      .catch((e: any) => window.App.allowDebugErrorMessages && console.log(e))
  }, [])

  const handleOnClick = (applet: Applet, i: number) => {
    logIFTTTNextAction("click", {
      location_type: "connection",
      connection_status: applet.status,
      connection_type: applet.config_type,
      object_id: applet.id,
      object_type: "connection",
      position: i,
    })
  }

  return (
    <div className="recommended-applets">
      <h4 className="cta">More like this</h4>
      <ul className="web-applet-cards">
        {recommendedApplets.map((applet, i) => (
          <li className="my-web-applet-card web-applet-card" key={i}>
            <SmallAppletCard
              onAppletClick={handleOnClick.bind(null, applet, i)}
              appletPath={appletOrConnectionPath(applet)}
              applet={applet}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

const recommendedAppletQuery = gql`
  query($moduleNames: [String!], $count: Int) {
    recommended_applets_for_channels(module_names: $moduleNames, count: $count) {
      ${myAppletsNormalizedAppletFields}
    }
  }
`

AppletRecommendations.fetchRecommendedApplets = (
  services: any[],
  isDesktop: boolean
) =>
  graphQueryBang(recommendedAppletQuery, {
    moduleNames: services,
    count: isDesktop ? 6 : 3,
  })

export default AppletRecommendations
